<template>
    <div class="clearfix go-tree-ctl" v-if="search">
        <div class="search-div pull-left" style="width:100%">
            <div class="input-icon account-sel-div">
                <input type="text" ref="searInput" AUTOCOMPLETE="off" @input="inputSearchVal($event)" placeholder="输入查询条件" class="form-control" style="border: 0;">
                <div class="search-btn">
                    <i class="ivu-icon ivu-icon-ios-search-outline" style="font-size: 18px;"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'go-search-bar',
        props: {
            search: {
                type: Boolean,
                default: false
            }
        },
        mounted(){

        },
        methods:{
            inputSearchVal($event){
                this.$emit('inputSearchVal',$event.target.value);
            },
        },
        computed: {

        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/commponents/go-search-bar.vue